const RejectConditionFormTestIdsScope = {
  REJECT_CONDITION_FORM: 'reject-condition-form',
};

export const RejectConditionFormTestIds = {
  REASON_INPUT: `${RejectConditionFormTestIdsScope.REJECT_CONDITION_FORM}.reason-input`,
  CANCEL_BUTTON: `${RejectConditionFormTestIdsScope.REJECT_CONDITION_FORM}.cancel-button`,
  REJECT_BUTTON: `${RejectConditionFormTestIdsScope.REJECT_CONDITION_FORM}.reject-button`,
};
